import { render, staticRenderFns } from "./GmbAttributeChangeItem.vue?vue&type=template&id=038ec018&scoped=true&"
import script from "./GmbAttributeChangeItem.vue?vue&type=script&lang=js&"
export * from "./GmbAttributeChangeItem.vue?vue&type=script&lang=js&"
import style0 from "./GmbAttributeChangeItem.vue?vue&type=style&index=0&id=038ec018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038ec018",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
